import { Info } from "lucide-react";

import { cn } from "src/lib/utils";

const InfoBox = ({
  children,
  icon: Icon = Info,
  className,
  iconClassName,
  ...props
}) => {
  return (
    <div
      className={cn(
        "bg-muted/50 flex items-center gap-2 rounded-md border p-3",
        className
      )}
      {...props}
    >
      <Icon
        className={cn(
          "text-muted-foreground size-5 flex-shrink-0",
          iconClassName
        )}
      />
      <div className="text-muted-foreground text-sm">{children}</div>
    </div>
  );
};

export { InfoBox };
